import { useHistory } from 'react-router-dom';
import { DeclarativeModal } from 'seagull';
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import { useOnMount } from "../../hooks/useOnMount";
import { selectors } from "../../store/state-selectors";
import { makeSentryIgnoredError } from "../ErrorBoundaryPage";
import { AgreementStudioProposalMode } from "./AgreementStudioProposalMode";
import { useFetchAgreementStudioData } from "./useFetchAgreementStudioData";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AgreementStudio(props) {
  const {
    returnRoute,
    draft,
    autoSaveTimeout,
    viewProposalMode,
    disableDataFetching,
    onClose
  } = props;
  const history = useHistory();
  const {
    fetchLegalTerms
  } = useStoreActions();
  const worksAt = useStore(selectors.user.business);
  const userEmail = useStore(selectors.user.email);
  const fetchAgreementStudioData = useFetchAgreementStudioData();
  useOnMount(() => {
    if (!disableDataFetching) fetchAgreementStudioData();
  });
  if (!worksAt || !userEmail) throw makeSentryIgnoredError('noBusiness');
  return /*#__PURE__*/_jsx(DeclarativeModal, {
    isOpen: true,
    onClose: onClose,
    content: _ref => {
      let {
        dismissModal
      } = _ref;
      return /*#__PURE__*/_jsx(AgreementStudioProposalMode, {
        isTemplateProposal: false,
        autoSaveTimeout: autoSaveTimeout,
        viewProposalMode: viewProposalMode,
        draft: draft || null,
        worksAt: worksAt,
        userEmail: userEmail,
        onUploadLegalTermsDocument: fetchLegalTerms,
        onClose: () => {
          if (returnRoute) {
            if (history.location.pathname !== returnRoute) {
              history.push(returnRoute);
            }
          } else {
            const canGoBack = history.length > 1;
            const locationState = history.location.state;
            const isFromPostAgreementFlow = locationState === null || locationState === void 0 ? void 0 : locationState.fromPostAgreement;
            if (canGoBack && !isFromPostAgreementFlow) {
              history.goBack();
            } else {
              history.push(routes.proposalsDashboard);
            }
          }
          dismissModal();
        }
      });
    }
  });
}